import { Basic } from "../basic.js";
import { debounce, toBool } from "../../lib/utils.js";
import styles from '../../styles/tooltip.css'

/**
 * @class MSDataTree
 * @extends Basic
 * @classdesc Дерево одиночного/множественного выбора
 */
export class MSDataTree extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "datasource",
            "sourcetype",
            "multiselect",
            "expanded",
            "idfield",
            "rootidfield",
            "displayfield",
            "value",
            "values",
            "onapply",
            "rootitem",
            "autoselect",
            "filter",
            "filtercallback",
            "childrenfield",
            "flagbackgroundfill",
            "flagtransparency",
            "flagshadowsize",
            "flagshadowcolor",
            "flagcursorview",
            "flagradius",
            "flagindicatorcolor",
            "flagframethickness",
            "flagframecolor",
            "flagframestyle",
            "fontname",
            "fontsize",
            "texthorizontalalign",
            "textverticalalign",
            "fontitalic",
            "fontbold",
            "fontmultiline",
            "fontunderlined",
            "textcolor",
            "expandedlevel",
            "displaynametype",
            "valuetype",
            "issavestate",
        ]);
    }

    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = `
            <style>
                * {
                    box-sizing: border-box;
                }
        
                :host {
                    flex-direction: column;
                }
                
                .tree {
                    width: 100%;
                    height: 100%;
                    padding-right: 20px;
                    line-height: normal;
                    user-select: none;
                }
                
                form {
                    overflow: auto;
                    margin: 0;
                }
                
                li {
                    position: relative;
                    font-size: 0;
                }
                
                    li:not(:last-child) > label {
                        border-left: 1px solid var(--main-tree-color);
                    }
                
                    li:not(:last-child) > ul {
                        border-left: 1px solid var(--main-tree-color);
                    }
                
                label:before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 18px;
                    height: calc(var(--font-size) / 2);
                    border-bottom: 1px solid var(--main-tree-color);
                }
                
                li:last-child > label:before {
                    border-left: 1px solid var(--main-tree-color);
                }
                
                .tree .li-before-hidden > label {
                    border: none;
                }
                
                    .tree .li-before-hidden > label:before {
                        border-left: 1px solid var(--main-tree-color);
                    }
                
                .tree .li-before-hidden > ul {
                    border: none;
                }
                
                .hidden {
                    display: none;
                }
                
                .tree__searchbox {
                    padding: 5px 5px 5px 8px;
                    border: none;
                    background-color: #ccc;
                    width: 100%;
                }
                
                .tree__checkbox-wrapper {
                    box-sizing: border-box;
                    display: inline-flex;
                    align-items: center;
                    min-width: var(--font-size);
                    height: var(--font-size);
                    margin-right: 3px;
                    margin-top: 3px;
                }
                
                .tree__checkbox {
                    display: none;
                }
                
                input:checked + .tree__checkbox-wrapper .tree__checkbox {
                    display: block;
                }
                
                label {
                    font-size: 16px;
                }
                
                    label > div {
                        pointer-events: none;
                    }
                
                    label.select > div {
                        background-color: #808080;
                    }
                
                .tree label {
                    position: relative;
                    display: inline-flex;
                    padding: 0 0 0 19px;
                    cursor: inherit;
                }
                
                ul {
                    padding-inline-start: 29px;
                    list-style: none;
                    margin: 1px 2px;
                    white-space: nowrap;
                    margin: 0;
                }
                
                .cl {
                    position: absolute;
                    top: 0;
                    left: 0;
                    transform: translate(-50%, 50%);
                    min-height: 7px;
                    min-width: 7px;
                    width: calc(var(--font-size) / 2);
                    height: calc(var(--font-size) / 2);
                    padding: 0;
                    border: 1px solid var(--main-tree-color);
                    border-radius: 2px;
                    background-repeat: no-repeat;
                    background-color: #fff;
                    background-position: 50% 50%;
                    background-image: linear-gradient(to left, #1b4964, #1b4964), linear-gradient(#1b4964, #1b4964), linear-gradient(315deg, #a0b6d8, #e8f3ff 60%, #fff 60%);
                    background-size: 1px 50%, 50% 1px, 100% 100%;
                    cursor: pointer;
                    z-index: 1;
                }
                
                .open {
                    background-image: linear-gradient(#1b4964, #1b4964);
                    background-size: 50% 1px;
                }
                .head-content{
                    display: flex;
                }
                .clear{
                    background: #ADABAB;
                    transition: .3s;
                    cursor: pointer;
                }
                .clear:hover{
                    background: #BCBCBC;
                }
                .clear path{
                    fill: #D9D9D9;
                    transition: .3s;
                }
                .clear:hover path{
                    fill: #EEEEEE;
                }
            </style>
            <style>
                ${styles}
            </style>
            <div class="head-content">
                <div class="tooltip-ignore-hidden">
                    <div class="clear">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 18C13.675 18 15.0938 17.4188 16.2562 16.2563C17.4187 15.0938 18 13.675 18 12C18 10.325 17.4187 8.90625 16.2562 7.74375C15.0938 6.58125 13.675 6 12 6C11.1375 6 10.3125 6.17813 9.525 6.53438C8.7375 6.89063 8.0625 7.4 7.5 8.0625V6H6V11.25H11.25V9.75H8.1C8.5 9.05 9.04688 8.5 9.74062 8.1C10.4344 7.7 11.1875 7.5 12 7.5C13.25 7.5 14.3125 7.9375 15.1875 8.8125C16.0625 9.6875 16.5 10.75 16.5 12C16.5 13.25 16.0625 14.3125 15.1875 15.1875C14.3125 16.0625 13.25 16.5 12 16.5C11.0375 16.5 10.1687 16.225 9.39375 15.675C8.61875 15.125 8.075 14.4 7.7625 13.5H6.1875C6.5375 14.825 7.25 15.9062 8.325 16.7438C9.4 17.5813 10.625 18 12 18Z"/>
                        </svg>
                    </div>
                    <div class="tooltip-absolute">
                        <div class="tooltip">${i18next.t('tree_clear_tooltip')}</div>
                    </div>
                </div>
            </div>
            <form class="tree"></form>
        `;
        this.separator = "."; // разделитель в пути
        this.idfield = "ID";
        this._displayfield = "Name";
        this._tmpValues = [];
        this.autoselect = true;
        this._onapplay = false;
        this.clearBtn = shadowRoot.querySelector(".clear");
        this._main = shadowRoot.querySelector("form");
        this._headerContent = shadowRoot.querySelector(".head-content");
        this._style = shadowRoot.querySelectorAll("style")[0];
        this._onClick = this._onClick.bind(this);
        this._onChange = this._onChange.bind(this);
        this.clearBtn.addEventListener("click", this.clearState.bind(this))
        this._main.addEventListener("click", this._onClick);
        this._main.addEventListener("change", this._onChange);
        //
        this.datasource = "{}";
        this.sourcetype = this.getAttribute("sourcetype") || 0;
        this.expanded = true;
        this.inited = false;
        this.isFiltered = false;
    }

    afterInitialize() {
        if (this.inited) return;
        this.inited = true;
        if(this.issavestate){
            this.originPath = this.getOriginPath();
            let storedState = this.getItemState(this.originPath);
            if(storedState){
                this.openStates = structuredClone(storedState.openStates);
            }   
        }
        this.update();
        if(this.sourcetype !== undefined && this.sourcetype === 0){
            if (this.objectValues) {
                this.updateCheckboxesState();
                return;
            }
            this._calcSelect();
        }
    }

    addSearchbox() {
        if (this._headerContent.parentNode.querySelector(".tree__searchbox")) {
            // При обновлении данных древа не нужно заново создавать searchbox, если он уже есть
            return;
        }
        const input = document.createElement("input");
        input.type = "text";
        input.placeholder = `${i18next.t('search')}...`;
        input.className = "tree__searchbox";

        input.addEventListener("change", function (e) {
            e.stopPropagation();
        });

        let prevValue;

        const wrapper = debounce(val => {
            const newValue = val.toLowerCase();
            if (newValue === prevValue) {
                return;
            }
            prevValue = newValue;
            this.filterTree(newValue);
        }, 700);

        input.addEventListener("input", function (e) {
            wrapper(e.target.value);
        });

        this._headerContent.prepend(input);
    }

    filterTree(val) {
        this.isFiltered = Boolean(val.length)
        const searchValueEmpty = !this.isFiltered

        searchInUl(this._main.querySelectorAll(":scope > ul > li"))

        function searchInUl(liArr) {
            let i = 0;
            const l = liArr.length;
            let needToHideUl;
            let visibleLiCount = l;
            let liBeforeHiddenIndex = -1;
            let prevLiBeforeHiddenIndex = -1;

            while (i < l) {
                const li = liArr[i];
                let label = li.querySelector("label");
                const ul = label.nextSibling;
                const needToHideLi = !label.textContent
                    .toLowerCase()
                    .includes(val);

                if (ul) {
                    needToHideUl = searchInUl(ul.childNodes);
                    ul.classList.toggle("hidden", needToHideUl);
                    li.querySelector(".cl").classList.toggle(
                        "hidden",
                        needToHideUl
                    );
                } else {
                    needToHideUl = true;
                }

                const isLiHidden = needToHideLi && needToHideUl;
                if(!isLiHidden && !searchValueEmpty){
                    const div = li.querySelector(".cl")
                    const ul = li.querySelector("ul")
                    if(div && ul){
                        div.classList.add("open")
                        ul.style.display = ""
                    }
                } else if(searchValueEmpty) {
                    const div = li.querySelector(".cl")
                    const ul = li.querySelector("ul")
                    if(ul && div){
                        const isOpen = div.classList.contains("open-without-filter");
                        div.classList.toggle("open", isOpen)
                        ul.style.display = isOpen ? "" : "none"
                    }
                }
                li.classList.toggle("hidden", isLiHidden);

                if (isLiHidden) {
                    visibleLiCount--;

                    const prevLiIndex = i - 1;
                    const prevLi = liArr[prevLiIndex];
                    if (prevLi && !prevLi.classList.contains("hidden")) {
                        liBeforeHiddenIndex = prevLiIndex;
                    }
                }

                if (
                    prevLiBeforeHiddenIndex === -1 &&
                    li.classList.contains("li-before-hidden")
                ) {
                    prevLiBeforeHiddenIndex = i;
                }

                if (i === l - 1) {
                    if (prevLiBeforeHiddenIndex > -1) {
                        liArr[prevLiBeforeHiddenIndex].classList.remove(
                            "li-before-hidden"
                        );
                    }

                    if (
                        liBeforeHiddenIndex > -1 &&
                        visibleLiCount &&
                        visibleLiCount < l
                    ) {
                        liArr[liBeforeHiddenIndex].classList.add(
                            "li-before-hidden"
                        );
                    }

                    needToHideUl = visibleLiCount === 0;
                }

                i++;
            }

            return needToHideUl;
        }
    }

    get expanded() {
        return this._expanded;
    }
    set expanded(v) {
        this._expanded = toBool(v);
    }

    /**
     * Уровень вложенности:
     * Если 0 - то дерево полностью открыто,
     * Если 1 - то открыты только корневые элементы,
     * И так далее
     * @type {number}
     */
    get expandedlevel() {
        return this._expandedLevel || 0;
    }

    set expandedlevel(v) {
        this._expandedLevel = Math.floor(v);
    }

    /**
     * Тип отображаемого имени:
     * 0 - имя,
     * 1 - описание
     * @type {enum}
     */
    get displaynametype() {
        return this._displayNameType || 0;
    }

    set displaynametype(v) {
        this._displayNameType = parseInt(v);
    }

    /**
     * Тип значения:
     * 0 - идентификатор: нужно проставить id и for
     * 1 - путь: id указывать не нужно, при выборе объекта нужно вычислять путь(path)
     * @type {enum}
     */
    get valuetype() {
        return this._valuetype || "0";
    }

    set valuetype(v) {
        this._valuetype = v;
    }

    // Если true - то это дерево множественного выбора
    // Если false - то это дерево одиночного выбора
    get multiselect() {
        return this._multiselect;
    }
    set multiselect(v) {
        this._multiselect = toBool(v);
    }

    get autoselect() {
        return this._autoselect;
    }
    set autoselect(v) {
        this._autoselect = this._toBool(v);
    }

    get sourcetype() {
        return this._sourcetype;
    }
    set sourcetype(v) {
        if (this._sourcetype === Number(v)) return;
        this._sourcetype = Number(v);
        switch (this._sourcetype) {
            case 0: // ProjectTree
                if($pr?.vmInfo?.projectTree){
                    this._datasource = $pr.vmInfo.projectTree;
                    this._createPath(this._datasource, "Name");
                    if (this.inited) {
                        // надо проверять инициализировался ли компонент или нет,
                        // в противном случае будет происходить двойной рендеринг дерева,
                        // поскольку файл json может загрузиться раньше инициализации
                        this.update();
                        if (this.objectValues) {
                            this.updateCheckboxesState();
                            return;
                        }
                        this._calcSelect();
                    }
                } else {
                    this._loadJSON("VMInfo.json", data => {
                        try {
                            this._datasource = JSON.parse(data).projectTree;
                            this._createPath(this._datasource, "Name");
                            if (this.inited) {
                                // надо проверять инициализировался ли компонент или нет,
                                // в противном случае будет происходить двойной рендеринг дерева,
                                // поскольку файл json может загрузиться раньше инициализации
                                this.update();
                                if (this.objectValues) {
                                    this.updateCheckboxesState();
                                    return;
                                }
                                this._calcSelect();
                            }
                        } catch (e) {
                            console.error(`cannot load tree: ${e.stack}`);
                            this._datasource = [];
                        }
                    });   
                }
                break;
            case 1: // object tree
                this._loadJSON("VMJournals.json", data => {
                    try {
                        this._datasource = JSON.parse(data).projectTree;
                        this._createPath(this._datasource, "ID");
                        if (this.inited) {
                            this.update();
                        }
                    } catch (e) {
                        console.error(`cannot load tree: ${e.stack}`);
                        this._datasource = [];
                    }
                });
                break;
            case 2: // CustomJson
                break;
        }
    }

    get datasource() {
        return this._datasource;
    }

    set datasource(value) {
        if (value === "{}") {
            return;
        }

        try {
            this._datasource = JSON.parse(value.toString());
            if (this.inited) {
                this.update();
            }
        } catch (e) {
            console.error(`cannot load tree: ${e.stack}`);
            this._datasource = [];
        }
    }

    get value() {
        return this._value;
    }

    set value(v) {
        this._value = v;
        this._calcSelect();
    }

    get values() {
        return this._values;
    }

    set values(v) {
        try {
            if (typeof v === "string") {
                this._values = JSON.parse(v);
            } else {
                this._values = v;
            }
        } catch (e) {
            console.error(`cannot load values: ${e.stack}`);
            this._values = [];
        }
        this._calcSelect();
    }

    /**
     * @example [{id: "Объекты.Объект 1.Параметр 2", title: "Объект 1.My best param"}]
     */
    get objectValues() {
        return this._objectValues;
    }

    set objectValues(v) {
        this._objectValues = v;
        if (this.inited) {
            this.updateCheckboxesState();
        }
    }

    get onapply() {
        return this._onapplay;
    }
    set onapply(v) {
        this._onapplay = toBool(v);
    }

    get rootitem() {
        return this._rootitem;
    }

    set rootitem(v) {
        this._rootitem = v;
        this.update();
    }

    // Эти 4 метода - Apply, Cancel, ClearAll и SelectAll можно задать внутри Masterscada.
    // Но для дерева выбора перьев в тренде их задать не получиться
    Apply() {
        this.SetParameter("values", this._tmpValues);
    }

    Cancel() {
        this._calcSelect();
    }

    ClearAll() {
        const checkbox = this._main.querySelectorAll(
            'input[type="checkbox"]:checked'
        );
        checkbox.forEach(el => {
            el.checked = false;
        });
        this._tmpValues = [];
        this.SetParameter("values", this._tmpValues);
    }

    SelectAll() {
        const isValueTypeIdentifier = this.isValueTypeIdentifier();
        const checkbox = this._main.querySelectorAll('input[type="checkbox"]');
        checkbox.forEach(el => {
            el.checked = true;
            this._tmpValues.push(
                isValueTypeIdentifier ? el.id : this.generatePath(el)
            );
        });
        this.SetParameter("values", this._tmpValues);
    }

    isValueTypeIdentifier() {
        return this.valuetype === "0";
    }

    _createPath(data, field, path) {
        data.forEach(el => {
            el.ItemPath = path
                ? `${path}${this.separator}${el[field]}`
                : `${el[field]}` || "";
            if (el?.[this.childrenfield]?.length) {
                this._createPath(el[this.childrenfield], field, el.ItemPath);
            }
        });
    }

    updateCheckboxesState() {
        this._main.querySelectorAll('input[type="checkbox"]').forEach(el => {
            el.checked = this.objectValues.some(x => x.id === el.id);
            if (el.checked && this.autoselect) {
                this._setValues(el.parentNode.parentNode);
            }
        });
    }

    get pennamelevel() {
        return this._pennamelevel;
    }
    set pennamelevel(v) {
        this._pennamelevel = v;
    }

    get issavestate(){
        return this._issavestate;
    }

    set issavestate(v){
        this._issavestate = this._toBool(v);
    }

    get idfield() {
        return this._idfield;
    }
    set idfield(v) {
        this._idfield = v;
    }

    get rootidfield() {
        return this._rootidfield;
    }
    set rootidfield(v) {
        this._rootidfield = v;
    }

    get displayfield() {
        return this._displayfield;
    }
    set displayfield(v) {
        this._displayfield = v;
    }

    get filter() {
        return this._filter;
    }
    set filter(v) {
        try {
            if (typeof v === "string") {
                this._filter = v === "" ? [] : JSON.parse(v);
            } else {
                this._filter = v;
            }
        } catch (e) {
            console.error(`cannot load filters: ${e.stack}`);
            this._filter = [];
        }
    }

    get childrenfield() {
        return this._childs || "Childs";
    }
    set childrenfield(value) {
        this._childs = value;
    }

    get filtercallback() {
        return this._filtercallback;
    }
    set filtercallback(value) {
        this._filtercallback = value;
    }

    /**
     * Цвет заливки фона активного флага
     * @type {string}
     */
    get flagbackgroundfill() {
        return this._flagbackgroundfill || "#fff";
    }

    set flagbackgroundfill(value) {
        this._flagbackgroundfill = value;
    }

    /**
     * Прозрачность флага
     * @type {number}
     */
    get flagtransparency() {
        return this._flagtransparency ?? 1;
    }

    set flagtransparency(value) {
        this._flagtransparency = value / 100;
    }

    /**
     * Размер тени флага (то есть размытие)
     * @type {number}
     */
    get flagshadowsize() {
        return this._flagshadowsize ?? 0;
    }

    set flagshadowsize(value) {
        this._flagshadowsize = +value;
    }

    /**
     * Цвет тени флага
     * @type {string}
     */
    get flagshadowcolor() {
        return this._flagshadowcolor || "transparent";
    }

    set flagshadowcolor(value) {
        this._flagshadowcolor = value;
    }

    /**
     * Вид курсора флага
     * @type {string}
     */
    get flagcursorview() {
        return this._flagcursorview || "default";
    }

    set flagcursorview(value) {
        this._flagcursorview = this.getCursor(+value);
    }

    /**
     * Радиус скругления флага
     * @type {string}
     */
    get flagradius() {
        return this._flagradius || "0px";
    }

    set flagradius(value) {
        this._flagradius = this._setValueUnit(value);
    }

    /**
     * Цвет индикатора флага
     * @type {string}
     */
    get flagindicatorcolor() {
        return this._flagindicatorcolor || "#0f7800";
    }

    set flagindicatorcolor(value) {
        this._flagindicatorcolor = value;
    }

    /**
     * Толщина рамки флага
     * @type {number}
     */
    get flagframethickness() {
        return this._flagframethickness ?? 1;
    }

    set flagframethickness(value) {
        this._flagframethickness = +value;
    }

    /**
     * Цвет рамки флага
     * @type {string}
     */
    get flagframecolor() {
        return this._flagframecolor || "#ccc";
    }

    set flagframecolor(value) {
        this._flagframecolor = value;
    }

    /**
     * Стиль рамки флага
     * @type {string}
     */
    get flagframestyle() {
        return this._flagframestyle || "solid";
    }

    set flagframestyle(value) {
        this._flagframestyle = this.getBorderStyle(+value);
    }

    /**
     * Семейство шрифта текста
     * @type {string}
     */
    get fontname() {
        return this._fontname || "Tahoma";
    }

    set fontname(value) {
        this._fontname = value;
    }

    /**
     * Размер шрифта текста
     * @type {number}
     */
    get fontsize() {
        return this._fontsize || 12;
    }

    set fontsize(value) {
        this._fontsize = value;
    }

    /**
     * Горизонтальное выравнивание текста
     * @type {enum}
     */
    get texthorizontalalign() {
        return this._texthorizontalalign;
    }

    set texthorizontalalign(value) {
        this._texthorizontalalign = value;
    }

    /**
     * Вертикальное выравнивание текста
     * @type {enum}
     */
    get textverticalalign() {
        return this._textverticalalign || 1;
    }

    set textverticalalign(value) {
        this._textverticalalign = value;
    }

    /**
     * Курсивный шрифт текста
     * @type {boolean}
     */
    get fontitalic() {
        return this._fontitalic;
    }

    set fontitalic(value) {
        this._fontitalic = value;
    }

    /**
     * Жирность шрифта текста
     * @type {boolean}
     */
    get fontbold() {
        return this._fontbold;
    }

    set fontbold(value) {
        this._fontbold = value;
    }

    /**
     * Многострочность текста
     * @type {boolean}
     */
    get fontmultiline() {
        return this._fontmultiline;
    }

    set fontmultiline(value) {
        this._fontmultiline = value;
    }

    /**
     * Подчёркивание текста
     * @type {boolean}
     */
    get fontunderlined() {
        return this._fontunderlined;
    }

    set fontunderlined(value) {
        this._fontunderlined = value;
    }

    /**
     * Цвет текста
     * @type {string}
     */
    get textcolor() {
        return this._textcolor || "#000";
    }

    set textcolor(value) {
        this._textcolor = value;
    }
    
    update() {
        if (!this._filter) this.filter = this.getAttribute("filter") || "";
        if (Array.isArray(this._datasource)) {
            this._main.style.setProperty("--main-tree-color", this.tryToGetUserColor(this.textcolor));
            this._main.style.setProperty("--font-size", `${this.fontsize}px`);
            let tree;
            if (this._rootitem) {
                const item = this.getObjects(
                    this._datasource,
                    this._rootidfield || this.idfield,
                    this._rootitem
                );
                this._datasourcefiltred = item.obj;
                const data = item.obj;
                this._main.innerHTML = "";
                tree = this._genEl(data);
            } else {
                this._datasourcefiltred = this._datasource;
                this._main.innerHTML = "";
                tree = this._genEl(this._datasource);
            }

            if (tree !== null) {
                this._main.appendChild(tree);
            }

            this._calcSelect();
            this.addSearchbox();
        } else {
            this._main.innerHTML = "";
        }
    }

    _calcSelect() {
        if (this._multiselect && this._values) {
            const inp = this._main.querySelectorAll('input[type="checkbox"]');
            inp.forEach(el => {
                el.checked = false;
            });
            const isValueTypeIdentifier = this.isValueTypeIdentifier();
            this._values.forEach(val => {
                const selector = isValueTypeIdentifier
                    ? `input[id="${val}"]`
                    : `input[data-path="${val}"]`;

                const element = this._main.querySelector(selector);

                if (element) {
                    element.checked = true;
                    if (this.autoselect) {
                        this._setValues(element.parentNode.parentNode);
                    }
                }
            });
            return;
        }

        if (!this._multiselect && this.value) {
            const selector = this.isValueTypeIdentifier()
                ? `[for="${this.value}"]`
                : `[data-path="${this.value}"]`;
            const element = this._main.querySelector(selector);
            if (element) {
                if (this._selectItem) {
                    this._selectItem.classList.remove("select");
                }
                this._selectItem = element;
                this._selectItem.classList.add("select");
            }
        }
    }

    clearState(){
        this._openStates = undefined;
        this.saveItemState({ openStates: undefined});
        this.update()
    }

    _genEl(ds, pathLevel = 1, accumulatedArray = []) {
        let ul = null;
        let needToHideUl = false;
        let savedState;
        for (let index = 0; index < ds.length; index++) {
            const el = ds[index];
            let nestedUl;
            if (
                el[this.childrenfield] &&
                Array.isArray(el[this.childrenfield]) &&
                el[this.childrenfield]?.length
            ) {
                const description = this.displaynametype ? el.Description || el.Name || el[this._displayfield] : el.Name || el[this._displayfield]
                const newAccumulatedArray = [...accumulatedArray];
                if(description) newAccumulatedArray.push(description)
                nestedUl = this._genEl(el[this.childrenfield], pathLevel + 1, newAccumulatedArray);
            }

            let checked = true;

            if (this._filtercallback && !nestedUl) {
                checked = this._filtercallback(el);
            }
            if (
                checked &&
                this._filter &&
                Object.keys(this._filter).length > 0 &&
                !nestedUl
            ) {
                checked = false;
                for (const key in this._filter) {
                    if (el.hasOwnProperty(key)) {
                        if (el[key] == this._filter[key]) {
                            checked = true;
                            break;
                        }
                    }
                }
                if (this.extendedSources?.includes(el.ItemPath)) checked = true
            }

            if (checked) {
                const neetToExpand =
                    this.expandedlevel && pathLevel > this.expandedlevel;
                
                if (!this.expanded && pathLevel !== 1 || this.expanded && neetToExpand) {
                    needToHideUl = true;
                }

                const list = document.createElement("li");

                const newAccumulatedArray = [...accumulatedArray];
                const description = this.displaynametype ? el.Description || el.Name || el[this._displayfield] : el.Name || el[this._displayfield]
                const pathWithoutDescription = this.createPathFromArray(newAccumulatedArray)

                if(this.issavestate && this.openStates && this.openStates[pathWithoutDescription] !== undefined){
                    needToHideUl = !this.openStates[pathWithoutDescription]
                }

                if(description) newAccumulatedArray.push(description)

                const pathWithDescription = this.createPathFromArray(newAccumulatedArray)

                if(this.issavestate && this.openStates && this.openStates[pathWithDescription] !== undefined){
                    savedState = this.openStates[pathWithDescription]
                }

                if (nestedUl) {
                    const neetToOpenSwitcher =
                        this.expandedlevel && pathLevel >= this.expandedlevel;
                    if(savedState !== undefined){
                        list.appendChild(this.createSwitcher(!savedState, pathWithDescription));
                    } else {
                        const isSwitcherClosed = !this.expanded || neetToOpenSwitcher;
                        list.appendChild(this.createSwitcher(isSwitcherClosed, pathWithDescription));
                    }
                }
                const value = this.createLabel(el[this.idfield], newAccumulatedArray)
                list.appendChild(value);

                if (nestedUl) {
                    list.appendChild(nestedUl);
                }

                if (ul === null) {
                    ul = document.createElement("ul");
                }

                ul.appendChild(list);
            }
        }

        if (needToHideUl && ul !== null) {
            ul.style.display = "none";
        }

        return ul;
    }

    createPathFromArray(nameArr){
        const index = nameArr.length > this.pennamelevel ? this.pennamelevel : nameArr.length
        const path = nameArr.slice(nameArr.length - index, nameArr.length).join('.')
        return path
    }

    createSwitcher(isClosed, path) {
        const switcher = document.createElement("div");
        switcher.dataset.value = path;
        switcher.classList.add("cl");
        if (!isClosed) {
            switcher.classList.add("open");
            switcher.classList.add("open-without-filter")
        }
        return switcher;
    }

    createCheckbox(forAttValue) {
        const createCheckbox = document.createElement("input");
        createCheckbox.setAttribute("type", "checkbox");

        if (this.isValueTypeIdentifier()) {
            const nameAtt = document.createAttribute("name");
            nameAtt.value = `item${forAttValue}`;
            createCheckbox.setAttributeNode(nameAtt);

            const idAtt = document.createAttribute("id");
            idAtt.value = forAttValue;
            createCheckbox.setAttributeNode(idAtt);
        }

        createCheckbox.style.display = "none";
        return createCheckbox;
    }

    createCheckboxWrapper(checkboxIcon) {
        const checkboxWrapper = document.createElement("div");
        checkboxWrapper.classList.add("tree__checkbox-wrapper");
        checkboxWrapper.style.opacity = this.flagtransparency;
        if (!this.flagtransparency) {
            return checkboxWrapper;
        }

        checkboxWrapper.style.border = `${this.flagframethickness}px ${this.flagframestyle} ${this.flagframecolor}`;

        if (this.flagshadowsize && this.flagshadowcolor !== "transparent") {
            checkboxWrapper.style.boxShadow = `0px 0px ${this.flagshadowsize}px ${this.flagshadowcolor}`;
        }

        if (this.flagradius !== "0px" && this.flagradius !== "0%") {
            checkboxWrapper.style.borderRadius = this.flagradius;
        }

        checkboxWrapper.appendChild(checkboxIcon);

        return checkboxWrapper;
    }

    createCheckboxIcon() {
        const svg = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "svg"
        );
        svg.classList.add("tree__checkbox");
        svg.setAttribute("viewBox", "0 0 12 10");

        const svgNS = svg.namespaceURI;
        const path = document.createElementNS(svgNS, "path");
        path.setAttribute(
            "d",
            "M11.9142 1.41421L4.20711 9.12132L0 4.91421L1.41421 3.5L4.20711 6.29289L10.5 0L11.9142 1.41421Z"
        );
        path.setAttribute("fill", this.flagindicatorcolor);
        svg.appendChild(path);
        return svg;
    }

    createLabel(forAttValue, nameArr) {
        const label = document.createElement("label");

        const title = this.createPathFromArray(nameArr)
        const name = nameArr.pop()
        label.setAttribute('item-title', title);

        if (this.isValueTypeIdentifier()) {
            const forAtt = document.createAttribute("for");
            forAtt.value = forAttValue;
            label.setAttributeNode(forAtt);
        }

        if (this.multiselect) {
            label.style.cursor = this.flagcursorview;
            label.appendChild(this.createCheckbox(forAttValue));
            label.appendChild(
                this.createCheckboxWrapper(this.createCheckboxIcon())
            );
        }

        label.appendChild(this.createTextWrapper(name));

        if (this.texthorizontalalign) {
            label.style.display = "flex";
        }

        return label;
    }

    createTextWrapper(text) {
        const div = document.createElement("div");
        div.textContent = text

        if (this.fontname) {
            div.style.fontFamily = '"' + this.fontname + '"';
        }

        if (this.fontsize) {
            div.style.fontSize = `${this.fontsize}px`;
            div.style.lineHeight = `${this.fontsize}px`;
        }

        if (this.texthorizontalalign) {
            div.style.textAlign =
                window._enums.AlignText[this.texthorizontalalign];
            div.style.flex = "1";
        }

        if (this.textverticalalign) {
            div.style.alignSelf =
                window._enums.AlignVertical[this.textverticalalign];
        }

        if (this._toBool(this.fontitalic)) {
            div.style.fontStyle = "italic";
        }

        if (this._toBool(this.fontbold)) {
            div.style.fontWeight = "bold";
        }

        if (this._toBool(this.fontmultiline)) {
            div.style.whiteSpace = "normal";
        }

        if (this._toBool(this.fontunderlined)) {
            div.style.textDecoration = "underline";
        }

        if (this.textcolor) {
            div.style.color = this.tryToGetUserColor(this.textcolor);
        }

        return div;
    }

    _loadJSON(filename, callback) {
        const xobj = new XMLHttpRequest();
        xobj.overrideMimeType("application/json");
        xobj.open("GET", filename, true);
        xobj.onreadystatechange = function () {
            if (xobj.readyState == 4 && xobj.status == "200") {
                callback(xobj.responseText);
            }
        };
        xobj.send(null);
    }

    disconnectedCallback() {
        this._filtercallback = null;
        this._main.removeEventListener("click", this._onClick);
        this._main.removeEventListener("change", this._onChange);
        super.disconnectedCallback();
    }

    getSiblings(elem) {
        var siblings = [];
        var sibling = elem.parentNode.firstChild;

        while (sibling) {
            if (sibling.nodeType === 1) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }

        return siblings;
    }

    getObjects(obj, key, val, path = []) {
        let objects = [];
        for (let i = 0; i < obj.length; i++) {
            const el = obj[i];
            path.push(el[this.idfield]);
            if (el[key] && el[key] == val) {
                objects.push(el);
                return { obj: objects, path: path, end: true };
            } else {
                if (el[this.childrenfield].length !== 0) {
                    const ret = this.getObjects(
                        obj[i][this.childrenfield],
                        key,
                        val,
                        path
                    );
                    if (ret && ret.end) {
                        return { obj: ret.obj, path: path, end: true };
                    } else {
                        path.pop();
                        continue;
                    }
                } else {
                    path.pop();
                }
            }
        }
    }

    setCheckboxBgColor(checkbox, bgColor) {
        this.getSiblings(checkbox).find(x =>
            x.classList.contains("tree__checkbox-wrapper")
        ).style.backgroundColor = this.tryToGetUserColor(bgColor);
    }

    _onChange(event) {
        const val = event.target.checked;
        const element = event.target.parentNode.parentNode;
        const tempObjectValues = [];

        if (this.autoselect) {
            const allCheckboxes = element.querySelectorAll(
                'input[type="checkbox"]'
            );
            allCheckboxes.forEach(el => {
                el.checked = val;
                el.indeterminate = false;
                this.setCheckboxBgColor(
                    el,
                    el.checked ? this.flagbackgroundfill : "transparent"
                );
            });

            this._setValues(element);
            const checkedCheckboxes = this._main.querySelectorAll(
                'input[type="checkbox"]:checked'
            );
            if (this.objectValues) {
                checkedCheckboxes.forEach(el => {
                    const hasChilds =
                        el.parentNode.parentNode.childNodes.length > 1;
                    if (!hasChilds) {
                        tempObjectValues.push({
                            id: el.id,
                            title: el.parentNode.getAttribute('item-title'),
                        });
                    }
                });
            } else {
                this._tmpValues = [];
                const isValueTypeIdentifier = this.isValueTypeIdentifier();
                checkedCheckboxes.forEach(el => {
                    const hasChilds =
                        el.parentNode.parentNode.childNodes.length > 1;
                    if (!hasChilds) {
                        this._tmpValues.push(
                            isValueTypeIdentifier
                                ? el.parentNode.getAttribute("for")
                                : this.generatePath(el)
                        );
                    }
                });
            }
        } else {
            const liArr = [...this._main.childNodes[0].childNodes];

            const getSelected = liArr => {
                let ret = [];
                liArr.forEach(el => {
                    const hasChilds = el.childNodes.length > 1;
                    const checkbox = el.childNodes[hasChilds ? 1 : 0].control;
                    if (checkbox.checked) {
                        ret.push(checkbox.id);
                    } else if (el.childNodes[2]) {
                        ret = ret.concat(
                            getSelected([...el.childNodes[2].childNodes])
                        );
                    }
                });
                return ret;
            };

            this._tmpValues = getSelected(liArr);
        }

        if (!this._onapplay) {
            if (this.objectValues) {
                this.SetParameter("objectValues", tempObjectValues);
            } else {
                this.SetParameter("values", this._tmpValues);
            }
        }
        this.onChange?.(this._tmpValues)
    }

    _setValues(element) {
        if (element.parentNode.parentNode.nodeName === "FORM") {
            return;
        }

        let count = 0,
            inde = 0;
        const sub = this.getSiblings(element);
        sub.forEach(el => {
            const e = el.querySelector('input[type="checkbox"]');
            count += Number(e.checked);
            inde += Number(e.indeterminate);
        });
        const curEl = element.parentNode.parentNode.querySelector(
            'input[type="checkbox"]'
        );

        if (sub.length === count) {
            curEl.indeterminate = false;
            curEl.checked = true;
        } else if (count === 0 && inde === 0) {
            curEl.checked = false;
            curEl.indeterminate = false;
        } else {
            curEl.checked = false;
            curEl.indeterminate = true;
        }

        this.setCheckboxBgColor(
            curEl,
            curEl.checked ? this.flagbackgroundfill : "transparent"
        );

        this._setValues(element.parentNode.parentNode);
    }

    get openStates(){
        return this._openStates;
    }

    set openStates(v){
        this._openStates = v;
    }

    _onClick(event) {
        const { target } = event;
        switch (target.nodeName) {
            case "DIV":
                target.classList.toggle("open");
                if(!this.isFiltered) target.classList.toggle("open-without-filter");
                target.parentNode.querySelector("ul").style.display =
                    target.classList.contains("open") ? "" : "none";
                const key = target.getAttribute("data-value");
                if(this.issavestate){
                    if(!this._openStates) this._openStates = {};
                    this._openStates[key] = target.classList.contains("open") ? true : false
                    this.saveItemState({ openStates: this.openStates });
                }
                event.preventDefault();
                break;
            case "LABEL":
                if (!this._multiselect) {
                    this.SetParameter("value", this.isValueTypeIdentifier() ? target.getAttribute("for") : this.generatePath(target), false, null, null, "", {
                        beforeCallbackFn: () => {
                            this._interaction = true;
                        },
                        afterCallbackFn: () => {
                            this._interaction = false;
                        },
                    });

                    event.preventDefault();
                }
                break;
        }
    }

    generatePath(target) {
        if (target.dataset.path) {
            return target.dataset.path;
        }

        let parent = target.parentNode;
        let path = "";
        while (parent.className !== "tree") {
            if (parent.tagName.toLowerCase() !== "li") {
                parent = parent.parentNode;
                continue;
            }

            const textContent = [...parent.childNodes].find(
                x => x.tagName.toLowerCase() === "label"
            ).textContent;

            path = textContent + (path ? this.separator + path : "");
            parent = parent.parentNode;
        }
        target.dataset.path = path;
        return path;
    }

    attributeChangedCallback(attrName, oldVal, newVal, itemIndex, forced) {
        if (attrName === "value" && !this._interaction) {
            if (this._rawValue === newVal)
                return;
            this._rawValue = newVal;
        }

        super.attributeChangedCallback(attrName, oldVal, newVal)
    }
}
